import { useEffect } from "react"
import { usePath } from "../libs/path/PathProvider"
import FileList from "../components/FileList"
import DragAndDrop, { IUpload } from "../libs/dragdrop/DragAndDrop"
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider"
import { useFilesProvider } from "../fmanlibs/FilesProvider"
import usePreviewDlg from "../components/Preview/PreviewDlg"
import { useUploadProvider } from "../fmanlibs/UploadProvider"

export default function Main(){
    const {hash,setHash} = usePath()
    const {addSnackbar} = useSnackbar()
    const {files, root} = useFilesProvider()
    const {openPreview} = usePreviewDlg()
    const {upload} = useUploadProvider()

    const onEnter = (e:any) => {}
    const onLeave = (e:any) => {}
    const onDrop = async (e:any) => {
        e.preventDefault()
        if (!root) return

        let files: IUpload[];
        try { files = await DragAndDrop.getFiles(root._id, e) }
        catch(e){
            addSnackbar(e)
            return
        }
        if (files.length==0) return

        upload(files)
    }

    useEffect(() => {
        const [_,action,fileId] = hash.split("/")
        if (files && action=="preview" && fileId) {
            const file = files.find(file => file._id==fileId)
            if (file) openPreview(file)
            else setHash("")
        }
    }, [hash,files])

    const onOver = (e:any) => { e.preventDefault(); e.stopPropagation }

return <div id="drop" className="flex1" onDragEnter={onEnter} onDragLeave={onLeave} onDrop={onDrop} onDragOver={onOver}>
        {files ? <FileList files={files} key={root?._id}/> : <></>}
    </div>
}